import { User } from "@auth0/auth0-react";

import config from "@/config";
import { UserRole } from "@/types/users";

export const getUserRole = (user: User | undefined): UserRole | null => {
  if (!user) {
    return null;
  }

  const rolesProperty = `${config.auth0Namespace}/roles`;
  const roles = user[rolesProperty];

  if (!roles || !Array.isArray(roles) || roles.length === 0) {
    return null;
  }

  return roles[0] as UserRole;
};
